// extracted by mini-css-extract-plugin
export default {"cardTitle":"StoryCards_cardTitle__UDoeD","cardDesc":"StoryCards_cardDesc__diCBu","card":"StoryCards_card__nyYI5","cardBody":"StoryCards_cardBody__BrDop"};